var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wlTreeSelect',{attrs:{"leaf":"","width":"240","checkbox":"","data":_vm.treeData,"showTotal":2},on:{"change":_vm.hindleChanged},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }